import React, { useEffect, useRef, useState } from 'react';
import 'rc-slider/assets/index.css';
import { ReactComponent as BiSearch  } from '../../assets/image/search-icons/search-icon.svg';
import { Image, Link } from '@shopify/hydrogen';
import CloseSearch from '../../assets/image/search-icons/close-search-header.svg';
import {isMobile, makeUrlSite, shortText} from '../../lib/Utils';
import IconRemove from '../../assets/image/search-icons/IconRemove.svg'
import { useAppDispatch, useAppSelector, useAppStore } from '../../lib/hooks';
import { searchBooks } from '../../store/slices/search';
import useDebounce from '../../lib/useDebounse';
import BookNotFoundImage from '../../assets/image/default-book-image-not-found.png';
import CleamSearch from '../../assets/image/clear.svg';
import { sendEvent } from '../../lib/analitycs';
import { useMetaAPI } from '../../hooks/useMetaAPI';

export default function SearchBar({isActiveSearch,setIsActiveSearch}) {
  const dispatch = useAppDispatch();
  const buttonPhone = useAppSelector((state) => state.searchui).buttonPhone;
  const [isOpen, setIsOpen] = useState(false);
  const {conversion} = useMetaAPI();
  const [isOpenMobile, setIsOpenMobile] = useState(false);
  const [isMobileDisp] = useState(isMobile());
  const [searchText, setSearchText] = useState('');
  const store = useAppStore();
  const debouncedValue = useDebounce(searchText, 300);
  const [resultsAutoc, setResultsAutoc] = useState([]);
  const [openSuggestions, setOpenSuggestions] = useState(false);
  const [showLastAndMoreSeatch, setShowLastAndMoreSeatch] = useState(true);
  const [lastSearch, setLastSearch] = useState([]);
  const [trendProductList, setTrendProductList] = useState([]);
  const [showTextLabel, setShowTextLabel] = useState(false);
  const [isOpenMobileIcon, setIsOpenMobileIcon] = useState(false);
  const inputRef = useRef(null); 

  useEffect(()=>{
    const url = 'https://search.ellibrero.com/autocomplete';
    const q = searchText;
    if(searchText.length > 2){
      fetch(url+'?q='+ encodeURIComponent(q), {
        method: 'GET',
        cache: "no-store"
      })
      .then(response => response.json())
      .then((data)=>{
        // console.log(data)
        setResultsAutoc(data);
        if(data !== null && data.length > 0){
          setOpenSuggestions(true)
        }else{        
          setOpenSuggestions(false)
        }
      });
    }
  },[debouncedValue])

  useEffect(()=>{
    if(isMobile()){
      setShowTextLabel(true);
    }
  },[])

  useEffect(() => {
    const handleClickOutside = (event) => {
      let options = document.getElementById('options-content');
      let inputSearch = document.getElementById('inputSearch');
      if (!options.contains(event.target) && !inputSearch.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
        document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(()=>{
    if(isMobile()){
      setTimeout(()=>{ 
        inputRef.current.click();
        inputRef.current.focus();

        if(isMobile()){
          if(!isOpenMobileIcon){
            document.body.classList.remove('overflow-hidden');
            document.body.classList.remove('head-search-active');
            setIsOpenMobileIcon(true)
          }else{
            document.body.classList.add('overflow-hidden');
            document.body.classList.add('head-search-active');
            setIsOpenMobileIcon(false)
          }
        }

      }, 1000);
    }
  }, [buttonPhone])

  const loadTrendingProducts = ()=>{
    fetch('https://search.ellibrero.com/trending?limit=6&o_hits=desc', {
      method: 'GET',
      cache: "no-store"
    })
    .then(response => response.json())
    .then((data)=>{
      setTrendProductList(data);
    });
  }

  const ListProductsSuggested = ()=>{
    let bookList = resultsAutoc ? resultsAutoc.slice(0,3) : [];

    const applyBold = (text)=>{
      return text.replace(searchText, '<b>'+ searchText +'</b>')
    };

    const trackEvent = (name, i)=>{
      sendEvent('select_suggestion',{
        suggestion_name: decodeURIComponent(name),
        suggestion_postion: i + 1
      });
    }

    return(
      <>
        {bookList.map((book, i) => (
          <div className='product' key={i}>
            <div className='line-sugested-1'>
              <Link
                to={`/producto/`+book.slug}
                key={i}
                reloadDocument="true"
                onClick={()=>{trackEvent(book.title, i)}}
              >
                <Image
                  src={book?.image ? book?.image : BookNotFoundImage}
                  width={27}
                  height={40}
                  alt="Delivery"
                />
              </Link>
            </div>
            <div className='line-sugested-2'>
              <Link
                to={`/producto/`+book.slug}
                key={i}
                reloadDocument="true"
                onClick={()=>{trackEvent(book.title, i)}}
              >
                <p className='title-book-sugg' dangerouslySetInnerHTML={{ __html: applyBold(book.title) }}></p>
                <div className='text-author'>{book.author}</div>
              </Link>
            </div>
          </div>
        ))}
      </>
    );
  }

  const LastSearchUser = ()=>{
    const removeItemSearch = (itemPos)=>{
      let searchMemory = localStorage.getItem('search-memory');
      searchMemory = (searchMemory) ? JSON.parse(searchMemory) : [];
      searchMemory = searchMemory.filter((item, i)=> i !== itemPos);
      setLastSearch(searchMemory);
      localStorage.setItem('search-memory', JSON.stringify(searchMemory));
    }

    const timestampToDate = (timestamp)=>{
      const date = new Date(timestamp);
      const months = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
      ];
    
      const day = date.getDate();
      const monthIndex = date.getMonth();
      const year = date.getFullYear();
    
      const monthName = months[monthIndex];
    
      return `${day} ${monthName} ${year}`;
    }

    const trackEvent = (text, date)=>{
      sendEvent('select_recent_term',{
        term: decodeURIComponent(text),
        date_term: timestampToDate(date)
      });
    }

    return(
      <>
        {lastSearch.map((search, i)=>(
            <div className='last-search-product' key={i}>
              <div>
                  <Link
                    to={makeUrlSite('search?q='+encodeURIComponent(search[0]))}
                    reloadDocument="true"
                    onClick={()=>{ trackEvent(search[0], search[1]); }}
                  >
                    <p><b>{search[0]}</b></p>
                    {timestampToDate(search[1])}
                  </Link>
              </div>
              <div>
                <Image
                  src={IconRemove}
                  width={20}
                  height={20}
                  alt="Delete"
                  onClick={()=>{removeItemSearch(i)}}
                  className='cursor-pointer'
                />
              </div>
            </div>
        ))}
      </>
    );
  }

  const MostSearchProduct = ()=>{    
    return (
      <>
        {trendProductList.map((book, i)=>(
          <div className='most-search-product' key={i}>
              <div className='image-container'>
              <Link
                  to={`/producto/`+book.slug}
                  key={i}
                  className='mx-auto my-auto'
                  reloadDocument="true"
                >
                  <Image
                      src={book?.image ? book?.image : BookNotFoundImage}
                      width={85}
                      height={'100%'}
                      className='mx-auto my-auto'
                      alt="Delivery"
                    />
              </Link>
              </div>
              <div className='title-product'>
                <div className='title-product-content'>
                <Link
                  to={`/producto/`+book.slug}
                  reloadDocument="true"
                  key={i}
                >
                  {shortText(book.title, 36)} 
                </Link>
                </div>
              </div>
          </div>
        ))}
      </>
    );
  }

  const generateSearch = (e)=>{
    e.preventDefault();

    let finalOrder = [];
    let searchMemory = localStorage.getItem('search-memory');
    searchMemory = (searchMemory) ? JSON.parse(searchMemory) : [];
    searchMemory = searchMemory.slice(0, 4);

    finalOrder.push([e.target.q.value, new Date().getTime()]);
    finalOrder = finalOrder.concat(searchMemory);

    localStorage.setItem('search-memory', JSON.stringify(finalOrder));

    dispatch(searchBooks(e.target.q.value))
    setSearchText('');
    setIsOpen(false);
    setResultsAutoc([]);
    
    conversion({
      event: 'search',
      text: e.target.q.value
    });

    location.href = makeUrlSite('search?q='+encodeURIComponent(e.target.q.value))
  }

  const onSearchText = (e)=>{
    let textSearch = e.target.value;
    if(textSearch){
      if(searchText.length > 1){
        setIsOpen(true); 
      }else{
        setIsOpen(false);
        setResultsAutoc([])
      }
      setSearchText(textSearch);
      setShowTextLabel(true);
    }else{
      setResultsAutoc([]);
      setSearchText("");
      if(!isMobile()){
        setShowTextLabel(false);
      }
    } 
  }

  const onClickSearch = (e)=>{
    setIsOpen(true);
    loadTrendingProducts();
    let searchMemory = localStorage.getItem('search-memory');
    searchMemory = (searchMemory) ? JSON.parse(searchMemory) : [];
    setLastSearch(searchMemory);
  }

  // const handleOnMouseLeave = (e)=>{
  //   setIsOpen(false);
  // }

  const cleanText = ()=>{
    setSearchText("");
  }

  return (
    <>
          <div className="w-full relative flex items-end justify-center">
          <div className="w-full" id='serach-bar-gen'>
            <div>
              <form className="relative searchform" id='search-bar' onSubmit={generateSearch}>
                <input
                  placeholder="¿Qué estas buscando hoy?"
                  className="librero-input w-full rounded-full text-purple-120 border-1 border-purple-120"
                  name="q"
                  id="inputSearch"
                  autoComplete="off"
                  value={searchText}
                  ref={inputRef}
                  onChange={onSearchText}
                  onClick={onClickSearch}
                >
                </input>
                  <Image
                    src={CleamSearch}
                    height={18}
                    width={18}
                    className={`${searchText.length ? 'clean-search' : 'hidden'}`}
                    alt=""
                    onClick={cleanText}
                  />
                  <div
                    className={`
                      fixed shadow-md rounded-b-md max-h-150
                      ${isOpen ? '' : 'hidden'} 
                      ${isMobileDisp ? 'right-0' : ''}
                    `}
                    id="options-content"
                  >
                    <div className='group-lines'>
                      {resultsAutoc?.length > 0 && openSuggestions && (
                        <>
                          <div className='title'>Sugerencias de resultados</div>
                          <div className='line-products list-products-suggested'>
                            <ListProductsSuggested />
                          </div>
                        </>
                      )}
                      {searchText == '' && showLastAndMoreSeatch && (
                        <>
                        {lastSearch.length > 0 && (
                          <>
                            <div className='title title-last-seach'>Tus últimas búsquedas</div>
                            <div className='line-products line-last-search'>
                              <LastSearchUser />
                            </div>
                          </>
                        )}
                          <div className='title'>Lo más buscado </div>
                          <div className='line-products line-most-searched'>
                            <MostSearchProduct />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                <button
                  type="submit"
                  className="hover:cursor-pointer bg-purple-120 rounded-tr-full rounded-br-full text-white p-3 absolute right-0 text-center items-center flex top-0 justify-center"
                >
                  <BiSearch className="text-2xl" />
                </button>
              </form>
              <label className={`${showTextLabel ? '' : 'hidden'}`}>Busca por libro, autor, ISBN o categoría</label>
            </div>
            <div className='close-button'>
              <Image 
                src={CloseSearch}
                width={33} 
                height={33}
                className='closeIcon'
                onClick={()=>{setIsActiveSearch(!isActiveSearch);}}
              />
            </div>
          </div>
        </div>
    </>
  );
}
